export const VISIBILITY = {
	HIGH_CONTRAST: "HIGH_CONTRAST",
	STANDARD: "STANDARD",
	MONOCHROME: "MONOCHROME",
};
